module.exports = {"id":"185020","name":"José Callejón","rating":"83","photo":"./data/images/photos/0/185020.png","club":{"name":"Naples","logo":"./data/images/clubs/Naples.png"},"positions":["AD"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JoseCallejon0.json
// module id = 2165
// module chunks = 0